import { IncrementalSha256 } from './filexfer';

/**
 * 恢复发送任务时只读取文件头尾的小样本，不把文件内容写入本地存储。
 * 最终传输仍会对完整内容做 SHA-256，这里的指纹只负责提前阻止明显的误选。
 */
export const FILE_SOURCE_FINGERPRINT_SAMPLE_BYTES = 64 * 1024;

type FingerprintSource = Pick<Blob, 'slice'> & { size: number };

async function digestRange(source: FingerprintSource, start: number, end: number): Promise<string> {
  const bytes = await source.slice(start, end).arrayBuffer();
  const hash = new IncrementalSha256();
  hash.update(bytes);
  return hash.digestHex();
}

/**
 * 返回 v1:<size>:<head sha256>:<tail sha256> 格式的源文件指纹。
 * 小文件的头尾样本会自然覆盖完整内容；大文件只读取最多 128KB。
 */
export async function fingerprintFileSource(source: FingerprintSource): Promise<string | undefined> {
  if (!source || !Number.isSafeInteger(source.size) || source.size < 0) return undefined;
  const sample = FILE_SOURCE_FINGERPRINT_SAMPLE_BYTES;
  try {
    const headEnd = Math.min(source.size, sample);
    const head = await digestRange(source, 0, headEnd);
    const tailStart = source.size > sample * 2 ? source.size - sample : 0;
    const tail = tailStart === 0 && source.size <= sample
      ? head
      : await digestRange(source, tailStart, source.size);
    return `v1:${source.size}:${head}:${tail}`;
  } catch {
    // 某些浏览器/系统文件提供器可能无法读取已选文件；调用方会回退到原有流程。
    return undefined;
  }
}
